<template>
  <section ref="root" class="dc-container">
    <div class="stars-container">
      <div 
        v-for="n in 50" 
        :key="n" 
        class="star" 
        :style="generateStarStyle()"
      ></div>
    </div>

    <div class="dc-card">
      <h2 ref="title" class="dc-title"><br /><br /><br /><br /><br /><br />
        <span>Dress</span><br />
        <span class="script">Code</span>
      </h2>

      <div ref="badge" class="dc-badge">FORMAL</div>

      <img
        ref="figure"
        src="@/assets/codigo.png"
        alt="Dress Code"
        class="dc-figure"
      />

      <p ref="note" class="dc-note">
        We kindly reserve all shades of blue<br /> and champagne gold exclusively for the quinceañera
      </p>

      <h3 ref="ideasTitle" class="ideas-title"> </h3>

   
    </div>

    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)
    const ideasTitle = ref(null)
    const linkHombre = ref(null)
    const linkMujer = ref(null)

    let observer = null

    const generateStarStyle = () => {
      return {
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        width: `${Math.random() * 3 + 1}px`,
        height: `${Math.random() * 3 + 1}px`,
        animationDuration: `${Math.random() * 3 + 2}s`,
        animationDelay: `${Math.random() * 3}s`
      }
    }

    onMounted(async () => {
      await nextTick()
      if (!root.value) return

      // ESTADO INICIAL DIVERSIFICADO PARA CELULAR
      gsap.set(title.value, { opacity: 0, y: -50 }) // Baja del cielo
      gsap.set(badge.value, { opacity: 0, scale: 0.5 }) // Crece desde el centro
      gsap.set(figure.value, { opacity: 0, x: 60, rotation: 5 }) // Entra de la derecha
      gsap.set(note.value, { opacity: 0, y: 30 }) // Sube
      gsap.set(ideasTitle.value, { opacity: 0, filter: 'blur(10px)' }) // Aparece desenfocado
      gsap.set(linkHombre.value, { opacity: 0, x: -40 }) // Entra de la izquierda
      gsap.set(linkMujer.value, { opacity: 0, x: 40 }) // Entra de la derecha

      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            const tl = gsap.timeline({ defaults: { ease: 'back.out(1.7)', duration: 0.8 } })

            tl.to(title.value, { opacity: 1, y: 0 })
              .to(badge.value, { opacity: 1, scale: 1 }, "-=0.5")
              .to(figure.value, { opacity: 1, x: 0, rotation: 0 }, "-=0.4")
              .to(note.value, { opacity: 1, y: 0, ease: 'power2.out' }, "-=0.4")
              .to(ideasTitle.value, { opacity: 1, filter: 'blur(0px)', duration: 1 }, "-=0.3")
              .to(linkHombre.value, { opacity: 1, x: 0 }, "-=0.7")
              .to(linkMujer.value, { opacity: 1, x: 0 }, "-=0.7")

            observer.disconnect()
          })
        },
        { threshold: 0.15, rootMargin: "0px 0px -50px 0px" } 
      )

      observer.observe(root.value)
    })

    onUnmounted(() => {
      if (observer) observer.disconnect()
    })

    return {
      root, title, badge, figure, note, ideasTitle, linkHombre, linkMujer, generateStarStyle
    }
  }
}
</script>

<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background-image: 
    linear-gradient(to bottom, 
      rgba(0, 0, 0, 0.516) 60%, 
      rgba(0, 0, 0, 0.7) 85%, 
      rgba(0, 0, 0, 0.95) 100%
    ),
    url('@/assets/descarga (3) - copia - copia.png');
  background-size: cover;
  background-position: center center; 
  background-repeat: no-repeat;
  padding: 34px 18px 42px;
  overflow: visible;
  margin-top:0px;
  text-align: center;
}

.dc-card { position: relative; z-index: 2; }

.dc-title {
  font-family: 'nombre', serif;
  color:#a48250;
  font-size: 36px;
  margin: 0 0 16px;
  line-height: 1.05;
}

.dc-badge {
  display: inline-block;
  background: #f7f4f4;
  color: #101010;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 15px;
  letter-spacing: 0.14em;
  padding: 8px 16px;
  border-radius: 8px;
  margin: 4px 0 12px;
}

.dc-figure {
  width: 180px;
  height: auto;
  display: block;
  margin: 10px auto 12px;
  filter: brightness(0) invert(0.75);
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 20px;
  color: #bcbfb4;
  opacity: 0.9;
  font-style: italic;
  margin: 10px auto 18px;
}

/* LINKS */
.ideas-title {
  margin-top: 20px;
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  color: #d4c6a1;
}

.ideas-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.idea-link {
  color: #d4c6a1;
  text-decoration: underline;
  font-family: 'padres', sans-serif;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.idea-link:hover {
  opacity: 0.7;
}
</style>
